const s =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] animate-pulse";

export const TicketHeaderShimmer = () => {
  return (
    <div className="flex flex-col gap-4 pt-4 pb-6 px-4">
      {/* Back arrow + Title + Ticket ID + action icons */}
      <div className="flex items-center gap-2.5">
        <div className={`w-[18px] h-[18px] rounded shrink-0 ${s}`} />

        <div className="w-full flex flex-col gap-1">
          <div className={`h-5 w-[60%] rounded ${s}`} />
          <div className="flex items-center gap-0.5">
            <div className={`w-4 h-4 rounded shrink-0 ${s}`} />
            <div className={`h-3.5 w-24 rounded ${s}`} />
          </div>
        </div>

        <div className="flex items-center gap-1 shrink-0">
          <div className={`w-[26px] h-[26px] rounded ${s}`} />
          <div className={`w-[26px] h-[26px] rounded ${s}`} />
        </div>
      </div>

      {/* Support banner */}
      <div className={`h-[40px] w-full max-w-full rounded-xl ${s}`} />

      {/* Row 1: Status, Assigned To, Priority */}
      <div className="flex flex-wrap gap-x-[18px] gap-y-3 items-start">
        {[130, 140, 110]?.map((w, i) => (
          <div key={i} className="flex flex-col gap-1 w-[150px]">
            <div className={`h-3 w-20 rounded ${s}`} />
            <div className={`h-[26px] rounded-md ${s}`} style={{ width: w }} />
          </div>
        ))}
      </div>

      {/* Row 2: Created, Created By, SLA Deadline, Last Updated */}
      <div className="flex flex-wrap gap-x-[18px] gap-y-3 items-center">
        {[120, 100, 135, 90]?.map((w, i) => (
          <div key={i} className="flex flex-col gap-1 w-[150px]">
            <div className={`h-3 w-20 rounded ${s}`} />
            <div className="flex items-center gap-1">
              {(i === 0 || i === 2 || i === 3) && (
                <div className={`w-3.5 h-3.5 rounded shrink-0 ${s}`} />
              )}
              <div className={`h-3.5 rounded ${s}`} style={{ width: w }} />
            </div>
          </div>
        ))}
      </div>

      {/* Row 3: Category, System Name, Site Name, Issue Type */}
      <div className="flex flex-wrap gap-x-[18px] gap-y-3 items-center">
        {[90, 80, 100, 95]?.map((w, i) => (
          <div key={i} className="flex flex-col gap-1 w-[150px]">
            <div className={`h-3 w-20 rounded ${s}`} />
            <div className={`h-[26px] rounded-md ${s}`} style={{ width: w }} />
          </div>
        ))}
      </div>

      {/* Row 4: Date Field */}
      <div className="flex flex-wrap gap-x-[18px] gap-y-3 items-start">
        <div className="flex flex-col gap-1 w-[150px]">
          <div className={`h-3 w-16 rounded ${s}`} />
          <div className={`h-[26px] w-[120px] rounded-lg ${s}`} />
        </div>
      </div>

      {/* Tags row */}
      <div className="flex flex-wrap items-center gap-2">
        <div className={`h-[24px] w-16 rounded ${s}`} />
        <div className={`h-[24px] w-14 rounded ${s}`} />
        <div className="h-3.5 w-px bg-border-gray dark:bg-border-gray-dk shrink-0" />
        <div className={`h-[26px] w-[90px] rounded-md ${s}`} />
        <div className={`h-[26px] w-[140px] rounded-md ${s}`} />
      </div>
    </div>
  );
};
